/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Grid, Row, Col } from 'react-bootstrap';
import s from './ServicesFooter.scss';
import { saveFooterHeight } from '../../actions/eservices';
import DistrictDetails from './DistrictDetails';
import WideLogo from './WideLogo';
import { portalMode } from '../../config';
import { PODLASKIE_MODE } from '../../constants'
import { layoutColorStyle, podlaskieLabelBackgroundColor, setFooterAndHeaderColors } from '../utils/utils';


class ServicesFooterClass extends React.Component {
  state = {
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
  }

  componentDidMount() {
    this.getFooterHeight();
    this.setTheme();
  }

  setTheme() {
    const {colors, sourceStyle, style} = setFooterAndHeaderColors('footer');
    this.setState({ colors, sourceStyle, style});
  }

  componentDidUpdate() {
    this.getFooterHeight();
  }
  getFooterHeight = () => {
    const foot = this.footer;
    const footHeight = foot.getBoundingClientRect().height;
    this.props.saveFooterHeight(footHeight);
  }

  getYear = () => {
    const d = new Date();
    const n = d.getFullYear();
    return n;
  };
  render() {
    return (
    <div>
      {
      portalMode == PODLASKIE_MODE ?
        <div style={{ backgroundColor: podlaskieLabelBackgroundColor, width: "100%", height:'10px'}}></div>
      : null
      }
      <footer ref={x => this.footer = x} style={this.state.style} className="servicesFooter my-bg footer" id="layout-footer">

      <Grid>
        <Row>
          <Col xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
            {
              this.props.prefix && this.props.arms ?
                <img height={'60'} src={`https://e-spdp.pl/oldihub/upload/herby/${this.props.arms}`} />
                : null
            }
          </Col>
          <Col xs={9} />
        </Row>
        <Row>
          <Col xs={12} sm={3} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '10px' }}>
            {
              this.props.prefix !== undefined ?
                <DistrictDetails prefix={this.props.prefix} style={this.state.style}/>
                : null
            }
          </Col>
          <Col xs={12} sm={9} >
            {
              this.props.prefix !== undefined ?
                <WideLogo prefix={this.props.prefix} />
                : null
            }
          </Col>
        </Row>
      </Grid>
      <div className="giap_link">
        <a className="link" href="http://www.giap.pl/" style={this.state.style}>
          GIAP © {this.getYear()}
        </a>
      </div>
    </footer>
    {/* <div className="info-tech">
      <b>Uwaga! Trwają prace nad przebudową portalu. Portal może nie działać prawidłowo. Pracujemy nad przywróceniem wszystkich funkcjonalności.</b>
    </div> */}
    </div>
    );
  }
}

const mapState = state => ({
  fontSize: state.runtime.fontSize,
  arms: state.eservices.arms,
});

const mapDispatch = {
  saveFooterHeight,
};

const ServicesFooter = connect(mapState, mapDispatch)(ServicesFooterClass);

export default withStyles(s)(ServicesFooter);



// WEBPACK FOOTER //
// src/components/ServicesFooter/ServicesFooter.js